import { CircularProgress as MuiCircularProgress } from '@mui/material'
import { CircularProgressProps } from './CircularProgress.types'

const CircularProgress = ({ size = 32, thickness = 4, ...props }: CircularProgressProps) => (
  <MuiCircularProgress size={size} thickness={thickness} {...props} />
)

export default CircularProgress
